// src/components/ui/tabs.jsx
import { createContext, useContext, useState } from "react"
import clsx from "clsx"

/* ------------------------------------------------------------------ */
/*  Tabs súper ligeros                                                */
/* ------------------------------------------------------------------ */
const TabsCtx = createContext()

export function Tabs({ defaultValue, children, className = "" }) {
  const [value, setValue] = useState(defaultValue)
  return (
    <TabsCtx.Provider value={{ value, setValue }}>
      <div className={className}>{children}</div>
    </TabsCtx.Provider>
  )
}

/* -------- contenedor de la “barra” -------- */
export function TabsList({ children, className = "" }) {
  return (
    <div
      className={clsx(
        "inline-flex gap-2 rounded-2xl p-1 bg-gray-800/70",
        "border border-white/10 shadow-inner",
        className
      )}
    >
      {children}
    </div>
  )
}

/* -------- cada pestaña clicable -------- */
export function TabsTrigger({ value, children, className = "" }) {
  const { value: active, setValue } = useContext(TabsCtx)
  const selected = active === value
  return (
    <button
      type="button"
      onClick={() => setValue(selected ? undefined : value)}
      className={clsx(
        "px-8 py-2 rounded-xl text-sm font-medium transition-all whitespace-nowrap min-w-[170px]",
        selected
          ? "bg-primary text-white shadow-md shadow-purple-500/30"
          : "text-gray-300 hover:bg-gray-700/60",
        className
      )}
    >
      {children}
    </button>
  )
}

/* -------- panel de contenido -------- */
export function TabsContent({ value, children }) {
  const { value: active } = useContext(TabsCtx)
  return active === value ? <div>{children}</div> : null
}
